<template>
  <div>
    <div>
      <img src="https://source.unsplash.com/collection/993239/600x400" alt="" width="600" height="400">
    </div>
    <p>
      Sunt dignissimos distinctio, veniam, tenetur aspernatur nulla!
    </p>
  </div>
  <div>
    <div>
      <img src="https://source.unsplash.com/collection/1673600/600x400" alt="" width="600" height="400">
    </div>
    <p>
      Corrupti, libero minima nihil expedita officiis? Quo.
    </p>
  </div>
  <div>
    <div>
      <img src="https://source.unsplash.com/collection/1513994/600x400" alt="" width="600" height="400">
    </div>
    <p>
      Alias rem, ab impedit recusandae repellat tempore.
    </p>
  </div>
  <div>
    <div>
      <img src="https://source.unsplash.com/collection/502925/600x400" alt="" width="600" height="400">
    </div>
    <p>
      Nisi inventore quo delectus perspiciatis voluptatibus, quae.
    </p>
  </div>
  <div>
    <div>
      <img src="https://source.unsplash.com/collection/1891993/600x400" alt="" width="600" height="400">
    </div>
    <p>
      Nisi harum earum consectetur laudantium iusto, laboriosam.
    </p>
  </div>
</template>

<script>
export default {
  name: "UnsplashSlides",
};
</script>
